/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentEntityType {
  ORDER = 'order',
  PAYMENT_LINK = 'payment_link',
  EXTRA_PAYMENT_LINE = 'extra_payment_line',
  VOUCHER = 'voucher',
  PASS = 'pass',
  PASS_PAYMENT = 'pass_payment',
}
